export const APIS_PATH = {
  API_BASE_URL: process.env.VUE_APP_API_BASE_URL,
  MANAGER: '/v1',
  USER: '/v2',
  PUBLIC: '/public',
};
